module.exports = __webpack_public_path__ + "img/visa.bceedad0.png";